import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export interface RatingProps {
  rating?: number;
  maxRating?: number;
  onRatingChange?: (rating: number) => void;
  readonly?: boolean;
  size?: "sm" | "md" | "lg";
  showValue?: boolean;
  className?: string;
}

export function Rating({
  rating = 0,
  maxRating = 5,
  onRatingChange,
  readonly = false,
  size = "md",
  showValue = false,
  className,
}: RatingProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  const handleStarClick = (starRating: number) => {
    if (readonly) return;
    onRatingChange?.(starRating);
  };

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <div className="flex items-center">
        {Array.from({ length: maxRating }, (_, index) => {
          const starRating = index + 1;
          const isFilled = starRating <= rating;

          return (
            <button
              key={index}
              type="button"
              onClick={() => handleStarClick(starRating)}
              disabled={readonly}
              className={cn(
                "transition-colors duration-150",
                !readonly && "cursor-pointer hover:scale-110",
                readonly && "cursor-default",
              )}
            >
              <Star
                className={cn(
                  sizeClasses[size],
                  isFilled
                    ? "fill-yellow-400 text-yellow-400"
                    : "fill-transparent text-gray-300 hover:text-gray-400",
                )}
              />
            </button>
          );
        })}
      </div>

      {showValue && (
        <span className="ml-2 text-sm text-gray-600">
          {rating}/{maxRating}
        </span>
      )}
    </div>
  );
}
